// extracted by mini-css-extract-plugin
export default {"SectionWrapper":"SectionWrapper_SectionWrapper__n551X"};